<template>
  <div class="page-container">
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="nav-content">
        <div class="company-logo">
          <h1 style="font-size: 1.2rem">广州添添健康信息咨询有限公司</h1>
        </div>
        <nav class="nav-links">
          <router-link to="/" class="nav-item">首页</router-link>
          <router-link to="/about" class="nav-item active">关于我们</router-link>
          <router-link to="/business" class="nav-item">业务板块</router-link>
        </nav>
      </div>
    </header>

    <!-- 关于我们横幅 -->
<!--    <section class="hero about-banner">-->
<!--      <div class="hero-content">-->
<!--        <h2 class="hero-title">关于添添健康</h2>-->
<!--        <p class="hero-subtitle">智慧养老新生态的开创者</p>-->
<!--      </div>-->
<!--    </section>-->

    <!-- 公司介绍 -->
    <section class="company-intro">
      <div class="content-wrapper">
        <h2 class="section-title">公司简介</h2>
        <div class="intro-grid">
          <div class="intro-box">
            <h3>企业使命</h3>
            <p>致力于打造中国口碑第一的银发用户生活服务电商平台</p>
          </div>

          <div class="intro-box">
            <h3>企业愿景</h3>
            <p>帮助1亿中国银发用户享受更健康美好生活</p>
          </div>

          <div class="intro-box full-width">
            <h3>添添健康产业集团有限公司</h3>
            <p>作为广州市重点招商引资项目企业，是国内银发经济领域的科技领军企业。我们响应国家战略政策，专注于为3亿银龄用户打造银发用户一站式生活服务电商平台，提供"兴趣教育、医疗养老、健康保健、文旅康养、日常消费等"特色产品与服务。依托集团强大的媒体、行业、流量资源，目标三年打造营收超30亿的科技型银发经济产业集团公司。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 企业价值观 -->
    <section class="values-section">
      <div class="content-wrapper">
        <h2 class="section-title">企业价值观</h2>
        <div class="values-grid">
          <div class="value-card">
            <div class="value-icon">👥</div>
            <h3>用户导向</h3>
            <div class="value-content">
              <p>坚持用户第一</p>
              <p>坚持口碑第一</p>
              <p>为用户提供"更优功效、更佳体验、物超所值"的产品与服务</p>
            </div>
          </div>

          <div class="value-card">
            <div class="value-icon">⭐</div>
            <h3>本分</h3>
            <div class="value-content">
              <p>正心、正念、正行</p>
              <p>利他共赢、长期主义</p>
              <p>抵御短期压力和诱惑干扰</p>
              <p>首先做正确的事情</p>
              <p>力求持续把事情做正确</p>
            </div>
          </div>

          <div class="value-card">
            <div class="value-icon">🎯</div>
            <h3>追求卓越</h3>
            <div class="value-content">
              <p>不满足于优秀</p>
              <p>始终追求卓越</p>
              <p>今天的最高表现是明天的最低要求</p>
              <p>主动求变，勇于创新</p>
            </div>
          </div>

          <div class="value-card">
            <div class="value-icon">📚</div>
            <h3>持续学习</h3>
            <div class="value-content">
              <p>打造学习型的组织</p>
              <p>借鉴并学习全球范围内正在进行的最佳实践</p>
              <p>科技与AI驱动</p>
              <p>每天有思考，每天有进步</p>
            </div>
          </div>

          <div class="value-card">
            <div class="value-icon">🤝</div>
            <h3>团队共赢</h3>
            <div class="value-content">
              <p>互信共赢</p>
              <p>团结协作</p>
              <p>鼓励相互合作</p>
              <p>共同实现目标</p>
              <p>雁行致远，共创辉煌</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 传媒集团介绍 -->
    <section class="media-section">
      <div class="content-wrapper">
        <h2 class="section-title">国内顶尖的添玺广告传媒集团</h2>
        <div class="media-content">
          <p>添玺集团旗下拥有添玺传媒集团与添添健康产业集团，添玺传媒集团成立于2003年，经过将近20年的积累,公司服务了一大批国内、国际知名企业和品牌,拥有丰富的客户及媒体资源。依托强大的媒体资源与客户资源,在持续围绕优质客户广告品牌营销服务的前提下,涉足影视、综艺、短视频、红人孵化、电商整合营销等业务。</p>
          <p>集团共设三大经营主体：广东添玺传媒广告有限公司、广州添玺传媒广告有限公司、京广添玺（北京）广告传媒有限公司(国有控股)。添玺传媒集团已发展成为集"媒体代理综合经营、品牌整合营销传播、媒体电商服务中心、多媒体IP运营、栏目制作剧集采购" 为一体的国内顶尖的整合传媒传播集团公司。</p>
        </div>
      </div>
    </section>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="content-wrapper">
<!--        <div class="footer-grid">-->
<!--          <div class="footer-info">-->
<!--            <h3>广东添添健康产业集团有限公司</h3>-->
<!--            <p>致力于打造中国领先的银发经济产业平台</p>-->
<!--          </div>-->
<!--          <div class="footer-contact">-->
<!--            <h4>联系我们</h4>-->
<!--            <p>电话：020-XXXXXXXX</p>-->
<!--            <p>邮箱：contact@example.com</p>-->
<!--            <p>地址：广州市XXX区XXX路XX号</p>-->
<!--          </div>-->
<!--        </div>-->
        <div class="footer-bottom">
          <p>© 2024 广州添添健康信息咨询有限公司 版权所有 备案号 <a href="https://beian.miit.gov.cn" target="_blank" style="color: rgba(255, 255, 255, 0.5)">粤ICP备2024303205号</a> </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'AboutPage',
  mounted() {
    // 初始化动画
    this.initAnimations();
    // 监听滚动以触发动画
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 清理事件监听
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    initAnimations() {
      // 初始化滚动动画，跳过首屏内容
      const sections = document.querySelectorAll('section:not(.hero)');
      sections.forEach(section => {
        const sectionTop = section.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        // 只对首屏以下的内容添加动画类
        if (sectionTop > windowHeight) {
          section.classList.add('scroll-animation');
        }
      });
    },
    handleScroll() {
      // 处理滚动动画
      const sections = document.querySelectorAll('.scroll-animation');
      sections.forEach(section => {
        const sectionTop = section.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        if (sectionTop < windowHeight * 0.75) {
          section.classList.add('animate');
        }
      });
    }
  }
}
</script>

<style scoped>
:root {
  --primary-color: #4169E1;
  --primary-light: #6B8FF2;
  --primary-dark: #2850B8;
  --text-primary: #2C3E50;
  --text-secondary: #526488;
  --card-bg: #ffffff;
  --light-bg: #f8f9ff;
}

/* 整体布局 */
.page-container {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  font-family: 'Microsoft YaHei', sans-serif;
}

.content-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
  box-sizing: border-box;
}

/* 导航栏样式 */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 15px 0;
  backdrop-filter: blur(5px);
}

.nav-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.company-logo h1 {
  font-size: 1.5rem;
  color: var(--primary-color);
  margin: 0;
  font-weight: 600;
}

.nav-links {
  display: flex;
  gap: 30px;
}

.nav-item {
  text-decoration: none;
  color: var(--text-primary);
  font-weight: 500;
  padding: 5px 0;
  position: relative;
  transition: color 0.3s ease;
}

.nav-item:hover,
.nav-item.active {
  color: var(--primary-color);
}

.nav-item::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background-color: var(--primary-color);
  transition: width 0.3s ease;
}

.nav-item:hover::after,
.nav-item.active::after {
  width: 100%;
}

/* 横幅样式 */
.hero {
  position: relative;
  padding: 120px 0 80px;
  background: linear-gradient(135deg, var(--primary-color), #7e57c2);
  color: white;
  overflow: hidden;
  margin-top: 60px;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  opacity: 0.15;
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
}

.hero-title {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 20px;
  line-height: 1.2;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  animation: fadeInUp 1s ease-out;
}

.hero-subtitle {
  font-size: 1.5rem;
  margin-bottom: 15px;
  font-weight: 500;
  line-height: 1.4;
  animation: fadeInUp 1s ease-out 0.2s both;
}

/* 公司介绍样式 */
.company-intro {
  padding: 80px 0;
  background: var(--light-bg);
}

.intro-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}

.intro-box {
  background: var(--card-bg);
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.intro-box.full-width {
  grid-column: 1 / -1;
}

.intro-box:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.intro-box h3 {
  color: var(--primary-color);
  font-size: 1.5rem;
  margin-bottom: 15px;
  font-weight: 600;
}

.intro-box p {
  line-height: 1.6;
  color: var(--text-secondary);
}

/* 企业价值观样式 */
.values-section {
  padding: 80px 0;
  background: linear-gradient(135deg, rgba(65, 105, 225, 0.05), rgba(126, 87, 194, 0.05));
}

.values-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-top: 40px;
}

.value-card {
  background: var(--card-bg);
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  text-align: center;
}

.value-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.value-icon {
  font-size: 2.5rem;
  margin-bottom: 20px;
}

.value-card h3 {
  color: var(--primary-color);
  font-size: 1.3rem;
  margin-bottom: 20px;
  font-weight: 600;
}

.value-content p {
  color: var(--text-secondary);
  margin-bottom: 10px;
  line-height: 1.5;
}

/* 传媒集团介绍样式 */
.media-section {
  padding: 80px 0;
  background: var(--light-bg);
}

.media-content {
  background: var(--card-bg);
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
}

.media-content p {
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: 20px;
  text-align: justify;
}

.media-content p:last-child {
  margin-bottom: 0;
}

/* 页脚样式 */
.footer {
  background: linear-gradient(to right, #333333, #444444);
  color: white;
  padding: 50px 0 30px;
}

.footer-grid {
  display: flex;
  justify-content: space-between;
  gap: 40px;
  margin-bottom: 30px;
}

.footer-info h3 {
  font-size: 1.3rem;
  margin-bottom: 15px;
  font-weight: 500;
}

.footer-info p {
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.5;
}

.footer-contact h4 {
  font-size: 1.1rem;
  margin-bottom: 15px;
  font-weight: 500;
}

.footer-contact p {
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 8px;
}

.footer-bottom {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-bottom p {
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.9rem;
}

/* 通用标题样式 */
.section-title {
  text-align: center;
  font-size: 2rem;
  margin-bottom: 40px;
  color: var(--primary-color);
  position: relative;
  padding-bottom: 15px;
  font-weight: 600;
}

.section-title::after {
  content: '';
  position: absolute;
  width: 60px;
  height: 3px;
  background: linear-gradient(to right, var(--primary-color), var(--primary-light));
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

/* 动画效果 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.scroll-animation {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.6s ease-out;
}

.scroll-animation.animate {
  opacity: 1;
  transform: translateY(0);
}

/* 响应式布局 */
@media (max-width: 1024px) {
  .values-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .intro-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 2.2rem;
  }

  .hero-subtitle {
    font-size: 1.2rem;
  }

  .footer-grid {
    flex-direction: column;
    text-align: center;
  }

  .nav-content {
    flex-direction: column;
    padding: 10px;
  }

  .nav-links {
    margin-top: 15px;
  }
}

@media (max-width: 576px) {
  .values-grid {
    grid-template-columns: 1fr;
  }

  .section-title {
    font-size: 1.8rem;
  }

  .value-card,
  .intro-box {
    padding: 20px;
  }
}
</style>